import { apiRequest } from "../_core/apiRequest";
import { unwrapProfileResponse } from "./profileResponseEnvelope";

export async function getProfile() {
  const response = await apiRequest({
    method: "get",
    path: "/profile/info",
    errorMessage: "Erro ao buscar dados da API",
  });

  return unwrapProfileResponse(response);
}
